import React, { useEffect } from "react";
import {
  Button,
  Input,
  Pagination,
  SelectMenu,
  Text,
} from "@zorni/components-lib";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { RESERVATION_STATUS } from "../../common/model/enum";

import TripReservationTable from "./components/TripReservationTable";
import { useManageTripReservation } from "./hooks/useManageTripReservation";

import styles from "./TripReservation.module.css";

const TripReservation = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const {
    reservations,
    reservationsLoading,
    reservationsRefreshing,
    error,
    currentPage,
    setCurrentPage,
    nbPages,
    search,
    setSearch,
    statusFilter,
    setStatusFilter,
    selectedEstablishment,
    setSelectedEstablishment,
    establishmentFilterOptions,
  } = useManageTripReservation();

  const statusOptions = [
    { value: "all", label: "Tous" },
    { value: RESERVATION_STATUS.CONFIRMED, label: "Confirmée" },
    { value: RESERVATION_STATUS.IN_PROGRESS, label: "En\u00A0attente" },
    { value: RESERVATION_STATUS.CREATED, label: "Créée" },
    { value: RESERVATION_STATUS.CANCELED, label: "Annulée" },
    { value: RESERVATION_STATUS.ARCHIVED, label: "Archivée" },
    { value: RESERVATION_STATUS.PASSED, label: "Passée" },
  ];

  useEffect(() => {
    if (error) {
      navigate("/error");
    }
  }, [error, navigate]);

  return (
    <div className={styles.page}>
      <div className={styles.headerCard}>
        <div>
          <Text as="h3" variant="heading" size="lg" weight="semibold">
            {t("tripReservation.tripReservation")}
          </Text>
          <Text size="sm" color="subtle">
            Administration des réservations
          </Text>
        </div>
      </div>

      <div className={styles.card}>
        <div className={styles.filterBar}>
          <div className={styles.searchWrapper}>
            <Input
              inputSize="small"
              iconLeft="iconSearch"
              placeholder="Rechercher..."
              value={search}
              onChange={(event) => setSearch(event.target.value)}
            />
          </div>

          <div className={styles.filtersRight}>
            <SelectMenu t={t}
              inputSize="small"
              options={establishmentFilterOptions}
              value={selectedEstablishment}
              onChange={(value, option) => setSelectedEstablishment(option.value)}
            />

            <div className={styles.statusToggle}>
              {statusOptions.map((option) => (
                <Button
                  key={option.value}
                  size="small"
                  variant={statusFilter === option.value ? "primary" : "secondary"}
                  label={option.label}
                  onClick={() => setStatusFilter(option.value)}
                />
              ))}
            </div>
          </div>
        </div>

        {/* Pas de Preloader plein écran ici : il recouvrirait la page à chaque
            filtre. Premier chargement : indicateur inline ; ensuite la table
            reste affichée, grisée pendant la requête. */}
        {reservationsLoading ? (
          <div className={styles.loading} role="status" aria-live="polite">
            <span className={styles.spinner} aria-hidden="true" />
            <Text size="sm" color="muted">
              Chargement des réservations…
            </Text>
          </div>
        ) : (
          <div
            className={reservationsRefreshing ? styles.refreshing : undefined}
            aria-busy={reservationsRefreshing}
          >
            <TripReservationTable reservations={reservations} />
          </div>
        )}

        <Pagination
          totalPages={nbPages}
          currentPage={currentPage}
          onPageChange={setCurrentPage}
        />
      </div>
    </div>
  );
};

export default TripReservation;
